<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <!-- Per-ticket details -->
  <ng-container *ngFor="let ticket of item.ticketItems; let i = index">
    <hr class="w-100 p-0 mb-3" style="border: none; border-top: 2px solid #000000;" />

    <div class="d-flex flex-column detail-item">
      <!-- Per-ticket status (only when multiple tickets) -->
      <div *ngIf="item.ticketItems.length > 1" class="d-flex justify-content-end align-items-start w-100 mb-3">
        <div class="d-flex flex-column justify-content-between mr-3" style="margin-top: 10px;">
          <span [class]="'status status-sidebar ' + getTicketStatusClass(ticket.status_id || ticket.statusId)">
            {{ ticket.status || ticket.statusName }}
          </span>
        </div>

        <ng-container *ngIf="(ticket.status_id || ticket.statusId) === 1 || (ticket.status_id || ticket.statusId) === 2">
          <button
            class="d-flex align-items-center justify-content-center py-1 px-1"
            style="border-bottom-left-radius: 10px; border: none; background-color: #facad3; width: 35px; height: 35px;"
            (click)="onRemoveItem(item)"
          >
            <!-- Cancel icon for "Reservado" tickets (statusId 2) -->
            <div
              *ngIf="(ticket.status_id || ticket.statusId) === 2"
              class="item-button"
              title="cancel"
            >
              <img
                src="../../../../../../assets/icons/itinerary-detail/04-01.svg"
                alt="cancel"
                style="
                  width: 20px;
                  filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                "
              />
            </div>

            <!-- Default trash icon for tickets in "Cotización" (statusId 1) -->
            <div
              *ngIf="(ticket.status_id || ticket.statusId) === 1"
              class="item-button"
              title="delete"
            >
              <svg version="1.1" id="Layer_2_00000146472910104976704670000005604375476625682068_"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                style="fill: #ff3f63; width: 20px;" xml:space="preserve">
                <path d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6
                  c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4
                  c9.4,0,17.1-7.6,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158
                  c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1,17.1,17.1H134.4
                  c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"/>
                <path d="M170.7,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5s-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                  C153.6,439.4,161.3,447,170.7,447z"/>
                <path d="M256,447c9.4,0,17-7.6,17.1-17V235.6c0-9.4-7.6-17.1-17.1-17.1c-9.4,0-17.1,7.6-17.1,17.1V430C239,439.4,246.6,447,256,447z
                  "/>
                <path d="M341.3,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5c-9.4-0.2-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                  C324.3,439.4,331.9,447,341.3,447z"/>
              </svg>
            </div>
          </button>
        </ng-container>
      </div>

      <div class="d-flex flex-column mb-3">
        <p
          style="
            font-family: 'Rubik';
            font-size: 14px;
            font-weight: 600;
            line-height: 1.2;
            text-transform: none;
          "
          class="m-0"
        >
          {{ ticket.ticket.option_name }} {{ ticket.paxAdults }} {{ ticket.paxAdults === 1 ? 'pasajero' : 'pasajeros' }}
        </p>
      </div>

      <div class="mb-2">
        <span *ngIf="ticket.rateClassId === 'R' || ticket.rateClass === 'R' || ticket?.pricing?.rateClass === 'R'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #34c26d; background-color: #defef4; text-transform: none; border-radius: 6px;">Reembolsable</span>
        <span *ngIf="ticket.rateClassId === 'NR' || ticket.rateClass === 'NR' || ticket?.pricing?.rateClass === 'NR'" class="px-2 py-1" style="font-size: 14px; font-family: 'Rubik'; font-weight: 400; line-height: 1; color: #ed3b5b; background-color: #fde6ea; text-transform: none; border-radius: 6px;">No Reembolsable</span>
      </div>

      <div class="row pt-3">
        <!-- Left Column -->
        <div class="col-6">
          <!-- Adults -->
          <div class="d-flex align-items-center mb-4" style="gap: 2px;">
            <img width="20" height="20" src="../../../../../../assets/icons/itinerary/persona.svg"/>
            <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ ticket.adults }} {{ ticket.adults === 1 ? 'Adulto' : 'Adultos' }}</span>
          </div>

          <!-- Date -->
          <div class="d-flex flex-column mb-4">
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1;
                color: #3e3e3e;
                text-transform: none;
              "
            >
              Fecha:
            </span>
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 500;
                line-height: 1;
                color: #000000;
                text-transform: none;
              "
            >
              {{ ticket.selectDay | date: "EEE. dd MMM yyyy" }}
            </span>
          </div>

          <!-- Start Time -->
          <div class="d-flex flex-column mb-4">
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1;
                color: #3e3e3e;
                text-transform: none;
              "
            >
              Inicio:
            </span>
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 500;
                line-height: 1;
                color: #000000;
                text-transform: none;
              "
            >
              {{ ticket?.experience?.sessions ? ticket?.experience?.sessions + ' hs.' : ticket?.selectHour + ' hs.' }}
            </span>
          </div>

          <div class="d-flex flex-column mb-4">
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1;
                color: #3e3e3e;
                text-transform: none;
              "
            >
              Idioma:
            </span>
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 500;
                line-height: 1;
                color: #000000;
                text-transform: none;
              "
            >
              {{ ticket.ticket?.language || 'No disponible' }}
            </span>
          </div>
        </div>

        <!-- Right Column -->
        <div class="col-6">
          <!-- Childrens -->
          <div class="d-flex align-items-center mb-4" style="gap: 2px;">
            <img width="20" height="20" src="../../../../../../assets/icons/search-result/hotel/NIÑO.svg"/>
            <span style="font-family: 'Rubik'; font-size: 13px; font-weight: 400; text-transform: none;">{{ ticket.childrens }} {{ ticket.childrens === 1 ? 'Niño' : 'Niños' }}</span>
          </div>

          <!-- Time -->
          <div class="d-flex flex-column mb-4">
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1;
                color: #3e3e3e;
                text-transform: none;
              "
            >
              Horario:
            </span>
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 500;
                line-height: 1;
                color: #000000;
                text-transform: none;
              "
            >
              {{ ticket?.ticket?.option_name }}
            </span>
          </div>

          <!-- Duration -->
          <div class="d-flex flex-column mb-4">
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1;
                color: #3e3e3e;
                text-transform: none;
              "
            >
              Duración:
            </span>
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 500;
                line-height: 1;
                color: #000000;
                text-transform: none;
              "
            >
              {{ ticket?.ticket?.duration || 'No definido' }}
            </span>
          </div>

          <!-- City -->
          <div class="d-flex flex-column mb-4">
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 400;
                line-height: 1;
                color: #3e3e3e;
                text-transform: none;
              "
            >
              Ciudad:
            </span>
            <span
              style="
                font-family: 'Rubik';
                font-size: 13px;
                font-weight: 500;
                line-height: 1;
                color: #000000;
                text-transform: none;
              "
            >
              {{ ticket.form?.destination?.city_province }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Per-ticket price -->
    <div
      class="mr-3 mb-4"
    >
      <p
        class="m-0"
        style="
          font-family: 'Muli', sans-serif;
          font-size: 13px;
          font-weight: 400;
          line-height: 1.2;
          text-transform: none;
        "
      >
        Tarifa Ticket:
      </p>
      <div class="d-flex justify-content-start align-items-center" style="gap: 1px;">
        <p
          class="m-0"
          style="
            font-family: 'Rubik', sans-serif;
            font-size: 14px;
            font-weight: 600;
            line-height: 1.2
          ">
          {{ currencyAgency?.code }}
          <span *ngIf="(ticket?.statusId || ticket?.status_id) !== 5">{{ getTicketDisplayPrice(ticket) | number: "1.2-2" }}</span>
          <span *ngIf="(ticket?.statusId || ticket?.status_id) === 5">{{ 0 | number: "1.2-2" }}</span>
        </p>
        <usb-tooltip-convert-amount
          *ngIf="(ticket?.statusId || ticket?.status_id) !== 5"
          [clientsSettingAppBooking]="clientsSettingAppBooking"
          [currencyProduct]="currencyAgency?.code"
          [valueProduct]="getTicketDisplayPrice(ticket)">
        </usb-tooltip-convert-amount>
      </div>

      <div
        *ngIf="ticket?.currency !== currencyAgency?.code && (ticket?.statusId || ticket?.status_id) !== 5"
        class="d-flex justify-content-start flex-column"
      >
        <p
          class="mb-0"
          style="font-family: 'Rubik', sans-serif; font-size: 13px; font-weight: 500; line-height: 1.2;"
        >
          {{ ticket?.currency }} {{ ticket?.netPriceAgent | number: "1.2-2" }}
        </p>

        <span style="font-family: 'Muli', sans-serif; font-size: 10px; font-weight: 400; line-height: 1.2; text-transform: none;">
          impuestos incluidos
        </span>
      </div>
    </div>
  </ng-container>
</usb-base-item>
